import {
  SORT_TYPES,
  PRODUCTS_STATE,
  PRODUCT_TYPES,
  COMMON_CUSTOMIZE_LABELS
} from '@/containers/utils/constant.js';
export const ERROR_CODE = {
  XSS_FILTERED: 'XssFiltered',
  RESOURCE_ALREADY_EXISTS: 'ResourceAlreadyExists'
};
export const constant = {
  items: {
    all: { text: '전체', value: '' },
    moduleType: {
      mb: [
        { value: 'ls-log', text: 'Logstash(log)' },
        { value: 'ls-metric', text: 'Logstash(metric)' },
        { value: 'ls-delta', text: 'Logstash(delta)' },

        { value: 'mc-metric', text: 'Metric Collector(metric)' },
        { value: 'mc-delta', text: 'Metric Collector(delta)' },
        { value: 'cm', text: 'Collect Manager' }
      ],
      pb: [
        { value: 'vcenter', text: 'vCenter' },
        { value: 'nsx-t', text: 'NSX-T ' },
        { value: 'im', text: 'IM' },
        { value: 'so', text: 'SO' },
        { value: 'prometheus', text: 'Prometheus' }
      ]
    }
  },
  EXCEPTION_CHAR: ['\\\\', '&', '<', '>', "'", ';'],
  NOT_ALLOWED_REGEX: {
    PREVENT_XSS: /[\\&<>';]/g,
    COMMON: /[^a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ0-9_()[\]\s.]/g,
    COMMON_INPUT: /[^a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ0-9_()[\]\s.]/,
    PRODUCT_NAME: /[^a-zA-Z\u3130-\u318F\uAC00-\uD7AF0-9_\\-\s.]/g,
    EVENT_FILTER_NAME: /[^a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ0-9()[\]\s._]/g,
    EVENT_MESSAGE_PREFIX: /[^a-zA-Z가-힣0-9\s()[\]\-_.]/g,
    EVENT_ALARM_COMM: /[^a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ0-9_()[\]\s+.-]/g,
    EVENT_ALARM: /[^a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ0-9_()[\]\s.@-]/g,
    EVENT_ALARM_SEARCH: /[^a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ0-9_()[\]\s+.@-]/g,
    FILE_PATH: /[^a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ0-9_()[\]\s./\\]/g,
    MORNITORING_NAME: /[^a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ0-9\-_.\s]/g,
    LB_NAME: /[^a-zA-Z0-9_\\-]/g,
    LB_SERVICE_NAME: /[^a-zA-Z0-9\\-]/g,
    DB_VERSION: /[^a-zA-Z0-9.\\-]/g,
    CONNECTED_VPC: /[^a-zA-Z0-9]/g,
    SERVICE_DOMAIN: /[^a-z0-9.]/g,
    CLUSTER_NAME: /[^a-zA-Z]/g,
    GPU_CLUSTER_NAME: /[^a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ0-9_\\-\s]/g,
    FILTER: /[<>$#&()@!]/g,
    FILTER_FOR_NETWORKING: /[<>$#&()@!"\\]/g,
    IP_ADDRESS: /[A-Za-z\u3130-\u318F\uAC00-\uD7AF]|[^0-9.]/g,
    METRICNAME: /[^A-Za-z._]/,
    SPACE_REPLACE: /\s\s+/g,
    CONSECUTIVE_WHITE_SPACE: / {2,}/g, // Pls no change regex in here!!!
    NOT_ALLOWED_SPACE: / /g,
    CONSECUTIVE_DOT: /\.{2,}/g,
    FIRST_DOT: /^\.*/g,
    NOT_ALLOWED_TWO_DOT: /^([^\.]*\.[^\.]*)(\..*)?/,
    NOT_ALLOWED_DOT: /\./g
  },
  MODAL_SIZE: {
    width: 1600,
    height: 900
  },
  AuthorizationAction: {
    MONITOR_VIEW: 'MonitorView',
    MONITOR_SET: 'MonitorSet'
  },
  AuthorizationResult: {
    ALLOW: 'Allow',
    DENY: 'Deny',
    RESOURCE_NOT_FOUND: 'ResourceNotFound'
  },
  FILE_TYPE: [
    { txt: 'Chart (PNG)', type: 'image' },
    { txt: 'Chart Data (Excel)', type: 'excel' },
    { txt: 'Raw Data (Excel)', type: 'excel-raw' }
  ],
  CHART_TYPE: [
    {
      txt: 'Line',
      iconType: 'line',
      iconName: 'line_chart',
      chartType: 'line',
      type: 'line',
      chartExopt: {}
    },
    {
      txt: 'Stacked Area',
      iconType: 'line',
      iconName: 'stack_chart',
      chartType: 'line',
      type: 'stack',
      chartExopt: { areaStyle: {} }
    },
    {
      txt: 'Scatter',
      iconType: 'line',
      iconName: 'scatter_chart',
      chartType: 'scatter',
      type: 'scatter',
      chartExopt: { symbol: 'circle' }
    }
  ],
  MENU3DOTS: {
    PERFORMANCE: 'performance',
    LOG_SEARCH: 'log-search',
    EVENT_SETTING: 'event-setting'
  },
  EVENT_LEVEL: {
    FATAL: 'FATAL',
    WARNING: 'WARNING',
    INFORM: 'INFORM',
    ALL: 'ALL'
  },
  MODE_ASG: {
    INSTANCE: 'instance',
    ASG: 'asg'
  },
  DOMAIN_DOC: 'https://docs.g.samsungsdscloud.com/',
  DOCUMENTATION_GUIDE: 'userguide/management/cloud_monitoring/overview',
  MAX_SELECTED: 30,
  FILE_TYPE_EVENT_STATUS: [
    { txt: 'Chart (PNG)', type: 'image' },
    { txt: 'Chart Data (Excel)', type: 'excel' }
  ],
  SORT_TYPES,
  PRODUCTS_STATE,
  PRODUCT_TYPES,
  COMMON_CUSTOMIZE_LABELS,
  DEFAULT_LANGUAGE: 'en',
  LANGUAGES: { en: 'en-US', ko: 'ko-KR' }
};
Object.freeze(constant);
export default {
  install(Vue) {
    Vue.config.globalProperties.$const = constant;
  }
};
